import { InputLabel, makeStyles, MenuItem, Select, Theme } from '@material-ui/core';
import React, { ChangeEvent } from 'react';

import { defaultPlexColors } from '../../../common/colors';

type Props = {
  plexColor: string | null | undefined;
  handleColorChange: (event: ChangeEvent<{ name?: string | undefined; value: unknown }>) => void;
};

export const ColorSelector = ({ plexColor, handleColorChange }: Props): React.ReactElement => {
  const classes = useStyles();
  return (
    <div>
      <InputLabel shrink={true} id="colorLabel">
        Color
      </InputLabel>
      <Select
        labelId="colorLabel"
        id="colorSelect"
        value={plexColor || ''}
        className={classes.colorSelect}
        onChange={handleColorChange}
      >
        {defaultPlexColors.map((color) => (
          <MenuItem value={color} key={color}>
            <div style={{ backgroundColor: color, width: 200, height: 20 }} />
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  colorSelect: {
    height: 25,
    width: 200,
    display: 'flex',
    flexBasis: 200,
    marginTop: 3,
    marginBottom: 17,
  },
}));
